import React, { useState } from 'react'
import { Button, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap'
import { Alert, message } from 'antd'
import { useSelector } from 'react-redux'

import { storeDownloadToken } from '../../DownloadTokens/services'
import { getUri } from '../../../services/springApi'
import { handleError } from '../../../helpers'
import { Form } from 'react-bootstrap'

export default function DownloadReportModal({ visible, onClose, data }) {
	const user_id = useSelector(state => state.auth.user.id)
	const [loading, setLoading] = useState(false)
	const [from, setFrom] = useState('')
	const [to, setTo] = useState('')

	const onSubmit = () => {
		setLoading(true)
		let token = new Date().getTime()
		storeDownloadToken({ type: `Descarga de ${data.title}`, token, user_id })
			.then(() => {
				message.info('Generando reporte en nueva pestaña')
				window.open(`${getUri()}/reports/export/${data.slug}/${token}?from=${from}&to=${to}`)
			})
			.catch(error => handleError(error))
			.finally(() => setLoading(false))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible}>
				<ModalHeader toggle={onClose}>
					Descargar {data.title}
				</ModalHeader>
				<ModalBody>
					<Alert 
						type="info" 
						description="Al descargar el informe se generará un archivo excel en otra pestaña de su navegador." 
					/>
					{ data.date_range && (
						<>
							<Form.Group>
								<Form.Label>Desde <span className='text-danger'>*</span></Form.Label>
								<Form.Control 
									type="date" 
									value={from} 
									onChange={e => setFrom(e.target.value)} 
									required
								/>
							</Form.Group>
							<Form.Group>
								<Form.Label>Hasta <span className='text-danger'>*</span></Form.Label>
								<Form.Control 
									type="date" 
									value={to} 
									onChange={e => setTo(e.target.value)} 
									required
								/>
							</Form.Group>
						</>
					)}
					<Button 
						className='mt-2' 
						color="primary" 
						onClick={onSubmit} 
						disabled={loading}
					>
						Descargar Reporte{" "}
						{ loading && <Spinner size="sm" className='ml-2' /> }
					</Button>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}